import React from "react";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import {DEBUG} from "./utilitaires";
import {
  BsFillArrowUpSquareFill,
  BsFillArrowDownSquareFill,
} from "react-icons/bs";
import * as mem from "./recopieLotFournisseur";
import OptionsPays from "./OptionsPays";
// import {
//   getNomSousLotEnMemoire,
//   changerNomSousLotEnMemoire,
// } from "./recopieLot";

export default function FormSousLot(props) {
  const [open, setOpen] = useState(props.open);
  // console.log("dans FormSousLot, type: ", props.type);
  mem.checkSiExisteSousLot(props.ident, props.type);

  var val;
  val = mem.getChampSousLot(props.ident, "numTraceur");
  const [numTraceur, setNumTraceur] = useState(val);
  val = mem.getChampSousLot(props.ident, "numFournisseur");
  const [numFournisseur, setNumFournisseur] = useState(val);
  val = mem.getChampSousLot(props.ident, "nomFabricant");
  const [nomFabricant, setNomFabricant] = useState(val);
  val = mem.getChampSousLot(props.ident, "paysFabricant");
  const [paysFabricant, setPaysFabricant] = useState(val);

  val = mem.getChampSousLot(props.ident, "libelle");
  const [libelle, setLibelle] = useState(val);
  val = mem.getChampSousLot(props.ident, "descr");
  const [descr, setDescr] = useState(val);
  val = mem.getChampSousLot(props.ident, "pourcent");
  const [pourcent, setPourcent] = useState(val);
  val = mem.getChampSousLot(props.ident, "carbone");
  const [carbone, setCarbone] = useState(val);  
  val = mem.getChampSousLot(props.ident, "carboneRaj");
  const [carboneRaj, setCarboneRaj] = useState(val);  
  //setNumTraceur("10");
  val = mem.getChampSousLot(props.ident, "couleur");
  const [couleurTitre, setCouleurTitre] = useState(val);    
  // var couleurTitre = "black";
  //setCouleurTitre("black");

  // const [msgErreurNumTraceur, setMsgErreurNumTraceur] = useState("");
  // const [msgErreurNumFournisseur, setMsgErreurNumFournisseur] = useState("");
  // const [msgErreurNomFabricant, setMsgErreurNomFabricant] = useState("");
  // const [msgErreurPaysFabricant, setMsgErreurPaysFabricant] = useState("");
  // const [msgErreurLibelle, setMsgErreurLibelle] = useState("");
  // const [msgErreurDescr, setMsgErreurDescr] = useState("");
  // const [msgErreurPourcent, setMsgErreurPourcent] = useState("");
  // const [msgErreurCarbone, setMsgErreurCarbone] = useState("");
  // const [msgErreurCarboneRaj, setMsgErreurCarboneRaj] = useState("");

  var messageErreurNumTraceur = "";
  var messageErreurNumFournisseur = "";
  var messageErreurNomFabricant = "";
  var messageErreurPaysFabricant = "";
  var messageErreurLibelle = "";
  var messageErreurDescr = "";
  var messageErreurPourcent = "";
  var messageErreurCarbone = "";
  var messageErreurCarboneRaj = "";

  //  useEffect(() => {
  //   setCouleurTitre("black");
  //  },[])

  //setCouleurTitre("black");

  function testerNombre(nbre) {
    let nbrecorrect = /^[0-9]+$/i;
    let res = nbrecorrect.test(nbre);
    console.log("pour nbre sous lot: ", nbre, "resultat: ", res);
    return res;
  }

  function testerPourcentage(pour) {
    let nbrecorrect = /^[0-9]{4,4}$/i;
    let res = nbrecorrect.test(pour);
    console.log("pourcentage sous lot: ", pour, "resultat: ", res);
    return res;
  }

  function validerNumTraceur() {
    if (testerNombre(numTraceur.trim())) {
      let valnumtraceur = parseInt(numTraceur, 10);
      if (valnumtraceur > 0) {
        return true;
      }
    }
    messageErreurNumTraceur = "--numero lot traceur incorrect--";
    // setMsgErreurNumTraceur("--erreur sur le numero Traceur--"); //ou alors ce numero n'existe pas. Faire...
    //setCouleurTitre("red");
    return false;
  }

  function validerNumFournisseur() {
    //verifier
    if ((numFournisseur.trim()).length > 0) {
      return true;
    }
    messageErreurNumFournisseur =
      "--erreur dans le numéro du lot chez le sous-traitant--";
    // setMsgErreurNumFournisseur("--erreur sur le numero fournisseur--");
    return false;
  }

  function validerNomFabricant() {
    //verifier
    if ((nomFabricant.trim()).length > 0) {
      return true;
    }
    messageErreurNomFabricant = "--erreur dans le nom du fabricant--";
    // setMsgErreurNumFournisseur("--erreur sur le nom du fabricant--");
    return false;
  }

  function validerPaysFabricant() {
    //verifier
    if ((paysFabricant.trim()).length > 0) {
      return true;
    }
    messageErreurPaysFabricant = "--erreur dans le pays du fabricant--";
    // setMsgErreurNumFournisseur("--erreur sur le pays du fabricant--");
    return false;
  }

  function validerLibelle() {
    //verifier
    if ((libelle.trim()).length > 0) {
      return true;
    }
    messageErreurLibelle =
      "--erreur dans la désignation du lot du sous-traitant--";
    // setMsgErreurLibelle("--erreur sur le libelle--");
    return false;
  }

  function validerDescr() {
    //verifier
    if ((descr.trim()).length > 0) {
      return true;
    }
    messageErreurDescr =
      "--erreur dans la description du lot du sous-traitant--";
    // setMsgErreurDescr("--erreur sur le descriptif--");
    return false;
  }

  function validerPourcent() {
    if (testerPourcentage(pourcent.trim())) {
      return true;
    }
    messageErreurPourcent = "--erreur dans le pourcentage--";
    // setMsgErreurPourcent("--erreur sur le pourcentage--");
    return false;
  }

  function validerCarbone() {
    // if (DEBUG) console.log("dans souslot valider carbone, carbone est:  ", carbone);
    if (carbone.trim() == '' || testerNombre(carbone.trim())) return true;
    messageErreurCarbone = "--erreur sur l'empreinte carbone--";
    return false;      
  }

  function validerCarboneRaj() {
    // if (DEBUG) console.log("dans souslot valider carboneRaj, carbone est:  ", carboneRaj);
    if (carboneRaj.trim() == '' || testerNombre(carboneRaj.trim())) return true;
    messageErreurCarboneRaj = "--erreur sur l'empreinte carbone rajoutée--";
    return false;      
  }  



  async function validerCeSousLot() {
    let correct = true;
    if (props.type == "traceur") {
      if (!validerNumTraceur()) {
        correct = false;
      }
      if (!validerPourcent()) {
        correct = false;
      }
      if (!validerCarboneRaj()) {
        correct = false;
      }      
    }
    if (props.type === "fournisseur") {
      if (!validerNumFournisseur()) {
        correct = false;
      }
      if (!validerNomFabricant()) {
        correct = false;
      }
      if (!validerPaysFabricant()) {
        correct = false;
      }
      if (!validerLibelle()) {
        correct = false;
      }
      if (!validerDescr()) {
        correct = false;
      }
      if (!validerPourcent()) {
        correct = false;
      }
      if (!validerCarbone()) {
        correct = false;
      }  
      if (!validerCarboneRaj()) {
        correct = false;
      }       
    }
    //if (DEBUG) console.log("dans valider ce sous lot, je vais faire setCouleurTitre");
    //setCouleurTitre("black");
    // if (correct) {
    //   setCouleurTitre("black");
    // } else {
    //   setCouleurTitre("red");
    // }
    return correct;
  }

  // function validerCeSousLot() {
  //   console.log("je suis dans validerCeSousLot")
  //   validerNumTraceur()
  //   console.log("j'ai validé numTraceur")
  // }

  // console.log("props verif= ", props.verif)
  // validerCeSousLot()
  //setCouleurTitre("black");
  if (props.verif) {
    validerCeSousLot();
  }

  function changerNumTraceur(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "numTraceur", value);
    //setMsgErreurNumTraceur("");
    setNumTraceur(value);
    //setCouleurTitre("red");
  }
  function changerNumFournisseur(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "numFournisseur", value);
    //setMsgErreurNumFournisseur("");
    setNumFournisseur(value);
  }
  function changerNomFabricant(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "nomFabricant", value);
    //setMsgErreurNomFabricant("");
    setNomFabricant(value);
  }
  function changerPaysFabricant(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "paysFabricant", value);
    //setMsgErreurPaysFabricant("");
    setPaysFabricant(value);
  }
  function changerLibelle(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "libelle", value);
    //setMsgErreurLibelle("");
    setLibelle(value);
  }
  function changerDescr(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "descr", value);
    //setMsgErreurDescr("");
    setDescr(value);
  }
  function changerPourcent(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "pourcent", value);
    //setMsgErreurPourcent("");
    setPourcent(value);
  }
  function changerCarbone(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "carbone", value);
    //setMsgErreurCarbone("");
    setCarbone(value);
  }
  function changerCarboneRaj(e, value) {
    e.preventDefault();
    mem.changerChampSousLot(props.ident, "carboneRaj", value);
    //setMsgErreurCarboneRaj("");
    setCarboneRaj(value);
  }


  function truncate(str, limit) {
    if (str.length > limit) {
      let res = str.substr(0, limit) + "...";
      return res;
    }
    return str;
  }

  if (props.type === "traceur") {
    return (
      <>
        <h5 style={{color: couleurTitre, backgroundColor: "lightblue" }} className="ps-2">
          Sous-Lot n° {props.ident}
          <span
            className="ms-5"
            onClick={() => setOpen(!open)}
            style={{ cursor: "pointer" }}
          >
            {open ? <BsFillArrowUpSquareFill /> : <BsFillArrowDownSquareFill />}
          </span>
          <span>&nbsp;&nbsp;(lot traceur n° {numTraceur})</span>
        </h5>
        <Collapse in={open}>
          <Form>
            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Numero de Lot Traceur</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le numero Traceur du sous lot"
                value={numTraceur}
                onChange={(e) => changerNumTraceur(e, e.target.value)}
              />
              {/* <Form.Text className="text-muted">
                cette information sera inscrite dans la blockchain
              </Form.Text> */}
              <span style={{ color: "red", fontStyle: "italic" }}>
                {/* ici message erreur traceur */}
                {messageErreurNumTraceur && messageErreurNumTraceur}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Pourcentage</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le pourcentage du sous lot dans la composition sur 4 chiffres (5645 pour 56.45%)"
                value={pourcent}
                onChange={(e) => changerPourcent(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {/* ici message erreur pourcent */}
                {messageErreurPourcent && messageErreurPourcent}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">(optionnel) Empreinte carbone Rajoutée (en gCO2/Kg)</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez l'empreinte carbone rajoutée (en g/Kg)"
                value={carboneRaj}
                onChange={(e) => changerCarboneRaj(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {/* ici message erreur pourcent */}
                {messageErreurCarboneRaj && messageErreurCarboneRaj}
              </span>
            </Form.Group>

          </Form>
        </Collapse>
      </>
    );
  }

  if (props.type === "fournisseur") {
    return (
      <>
        <h5 style={{color: couleurTitre, backgroundColor: "lightblue" }} className="ps-2">
          Sous-Lot n° {props.ident}
          <span
            className="ms-5"
            onClick={() => setOpen(!open)}
            style={{ cursor: "pointer" }}
          >
            {open ? <BsFillArrowUpSquareFill /> : <BsFillArrowDownSquareFill />}
          </span>
          <span>&nbsp;&nbsp;(lot fournisseur {truncate(libelle, 20)})</span>
        </h5>

        <Collapse in={open}>
          <Form>
            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Dénomination du Lot</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="entrez la dénomination du lot"
                value={libelle}
                maxLength={1000}
                onChange={(e) => changerLibelle(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurLibelle && messageErreurLibelle}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">
                Numero de Lot Fabricant
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder={"entrez le numero de lot chez le fournisseur"}
                value={numFournisseur}
                maxLength={1000}
                onChange={(e) => changerNumFournisseur(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurNumFournisseur && messageErreurNumFournisseur}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Fabricant</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="entrez le nom du fabricant"
                value={nomFabricant}
                maxLength={1000}
                onChange={(e) => changerNomFabricant(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurNomFabricant && messageErreurNomFabricant}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Pays</Form.Label>
              <Form.Select
                value={paysFabricant}
                onChange={(e) => changerPaysFabricant(e, e.target.value)}
              >
                <OptionsPays />
              </Form.Select>
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurPaysFabricant && messageErreurPaysFabricant}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="entrez la description du sous lot"
                value={descr}
                maxLength={1000}
                onChange={(e) => changerDescr(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurDescr && messageErreurDescr}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">Pourcentage</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez le pourcentage du sous lot dans la composition sur 4 chiffres (5645 pour 56.45%)"
                value={pourcent}
                maxLength={1000}
                onChange={(e) => changerPourcent(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {messageErreurPourcent && messageErreurPourcent}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">(optionnel) Empreinte carbone(en gCO2/Kg)</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez l'empreinte carbone (en g/Kg)"
                value={carbone}
                onChange={(e) => changerCarbone(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {/* ici message erreur pourcent */}
                {messageErreurCarbone && messageErreurCarbone}
              </span>
            </Form.Group>

            <Form.Group className="mb-3" style={{ backgroundColor: "#d4d6d9" }}>
              <Form.Label className="ps-2">(optionnel) Empreinte carbone Rajoutée (en gCO2/Kg)</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                placeholder="entrez l'empreinte carbone rajoutée (en g/Kg)"
                value={carboneRaj}
                onChange={(e) => changerCarboneRaj(e, e.target.value)}
              />
              <span style={{ color: "red", fontStyle: "italic" }}>
                {/* ici message erreur pourcent */}
                {messageErreurCarboneRaj && messageErreurCarboneRaj}
              </span>
            </Form.Group>
          </Form>
        </Collapse>
      </>
    );
  }
}
